import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'
const Header = () => {
    return (
        <div>
            <div className="headerSeaction">
                <div>
                    <h1>Udvash Center</h1>
                </div>
                <nav className="link">
                    <Link to="/home" className='single-link'>Home</Link>
                    <Link to="/courses" className='single-link'>Courses</Link>
                    <Link to="/about" className='single-link'>About</Link>
                    <Link to="/contact" className='single-link'>Contact</Link>
                </nav>
            </div>
        </div>
    );
};

export default Header;